<template>
    <a :href="info.alias" class="flex-v-center flex-between link-reverse tourniquet-small-info">
        <span class="list-name">
            <picture class="list-photo" v-if="info.photo">
                <source :srcset="`${info.images.webp['size-50']} 1x, ${info.images.webp['size-100']} 2x`" type="image/webp">
                <source :srcset="`${info.images.photo['size-50']} 1x, ${info.images.photo['size-100']} 2x`" type="image/jpeg">
                <img :src="info.photo" alt="photo" loading="lazy" width="50" height="50">
            </picture>
            <span class="list-name-text">
                <span v-if="showLabel" class="tourniquet-small-info-label">Замінений на:</span>
                {{info.name}}
            </span>
        </span>
        <icon-chevron-big/>
    </a>
</template>
<script>

import IconChevronBig from '../../icons/IconChevronBig';

export default {
    name: "TourniquetSmallInfo",
    props: ['info', 'showLabel'],
    components: {
        IconChevronBig,
    }
}
</script>
<style lang="scss" scoped>
@import "../../../../../sass/front/helpers";

.tourniquet-small-info {
    text-decoration: none;

    & + & {
        margin-top: 12px;
    }

    &-label {
        font-size: 12px;
        font-weight: 300;
        margin-bottom: 6px;
        color: #959595;
        display: block;
    }

    .list {
        &-name {
            font-size: 14px;
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 12px;
            position: relative;

            &-text {
                margin-right: 8px;
                white-space: normal;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
            }
        }

        &-photo {
            position: static;
            display: inline-block;
            background-color: #fff;
            border: 1px solid #EEEEEE;
            border-radius: 9px;
            width: 50px;
            min-width: 50px;
            height: 50px;
            overflow: hidden;

            img {
                object-fit: contain;
                object-position: center;
                height: 100%;
                width: 100%;
            }
        }
    }
}


</style>
